import { motion } from 'framer-motion'
import { SeasonalTheme } from './SeasonalTheme'

export function Hero() {
  const { theme } = SeasonalTheme.useTheme()

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="relative px-6 py-8 pt-safe pt-10 flex flex-col items-center gap-4"
    >
      <motion.div
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ duration: 0.7, ease: [0.68, -0.55, 0.265, 1.55], delay: 0.1 }}
        className="relative"
      >
        <div className="w-24 h-24 rounded-3xl glass-strong flex items-center justify-center overflow-hidden p-2">
          <motion.img
            src="/logo.svg"
            alt="Squibbles Logo"
            className="w-full h-full object-contain"
            animate={{ rotate: [0, 2, -2, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
          />
        </div>
        <motion.div
          className="absolute -bottom-2 -right-2 w-6 h-6 rounded-full border-2 border-bg"
          animate={{ boxShadow: ['0 0 0 0 var(--theme-accent-glow)', '0 0 0 8px transparent'] }}
          transition={{ duration: 2, repeat: Infinity }}
          style={{ background: theme.accent }}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
        className="text-center"
      >
        <h1 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-white via-gray-100 to-gray-300 bg-clip-text text-transparent">
          Squibbles
        </h1>
        <motion.p
          className="mt-2 text-base text-zinc-400 font-medium"
          animate={{ opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        >
          Collectibles com alma. Edição limitada. {theme.emoji}
        </motion.p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        transition={{ duration: 0.3, delay: 0.5 }}
        className="w-full max-w-xs h-px bg-gradient-to-r from-transparent via-zinc-700 to-transparent"
      />
    </motion.header>
  )
}